import { render } from "./EmoneyPay.vue?vue&type=template&id=674da54a&scoped=true"
import script from "./EmoneyPay.vue?vue&type=script&lang=js"
export * from "./EmoneyPay.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=674da54a&scoped=true&lang=css"
import "@/assets/css/user/pages/menu.css?vue&type=style&index=1&id=674da54a&scoped=true&lang=css"
import "@/assets/css/user/pages/touchbox.css?vue&type=style&index=2&id=674da54a&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=3&id=674da54a&scoped=true&lang=css"
import "@/assets/css/user/dark/menu-dark.css?vue&type=style&index=4&id=674da54a&scoped=true&lang=css"
import "@/assets/css/user/dark/touchbox-dark.css?vue&type=style&index=5&id=674da54a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674da54a"]])

export default __exports__